module.exports = __webpack_public_path__ + "static/media/barberscape-1.06d5d201.jpg";